import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import store from './Redux/store';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import Resource from './Resource';
import Login from './Login';
import './Resource/Stylesheets/fontiran.css';
import './Resource/Stylesheets/reset.css';
import './Resource/Stylesheets/index.css';
import './Resource/Stylesheets/config.css';
import "./Resource/Stylesheets/responsive.css";
import Logout from './Logout';
import Layout from './Layout';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import Landing from "./Project/Landing";

ReactDOM.render(
    // <React.StrictMode>
    <Provider store={store}>
        <BrowserRouter>
            <Switch>
                <Route path={Resource.ROUTE.LOGIN} exact component={Login}/>
                <Route path={Resource.ROUTE.LOGOUT} exact component={Logout}/>
                <Route path={Resource.ROUTE.LANDING} exact component={Landing}/>
                <Route path={'/'} component={Layout}/>
            </Switch>
        </BrowserRouter>
    </Provider>,
    // </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
    onUpdate: registration => {
    },
    onSuccess: registration => {
    }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
